import { create } from 'zustand';

import { Link } from '@/types/link.type';

export interface LinkState {
  links: Array<Link> | [];
  isLoading: boolean;
  error: string | null;
  getLinks: () => Array<Link> | [];
  setLinks: (links: Array<Link> | []) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  createLink: (link: Link) => void;
  updateLink: (id: string, link: Link) => void;
  deleteLink: (id: string) => void;
  getVisibleLinks: () => Link[];
}

const useLinkStore = create<LinkState>((set, get) => ({
  links: [],
  isLoading: false,
  error: null,
  getLinks: () => get().links,
  setLinks: (links: Array<Link> | []) => set(() => ({ links, error: null })),
  setLoading: (isLoading: boolean) => set(() => ({ isLoading })),
  setError: (error: string | null) => set(() => ({ error })),
  createLink: (link: Link) =>
    set((state) => ({ links: [...state.links, link] })),
  updateLink: (id: string, link: Link) =>
    set((state) => ({
      links: state.links
        ? state.links.map((item) => (item.id === id ? link : item))
        : [],
    })),
  deleteLink: (id: string) =>
    set((state) => ({
      links: state.links.filter((item) => item.id !== id),
    })),
  getVisibleLinks: () => {
    const { links } = get();
    // Filter links to show only those with franchisee_dashboard set to true
    return links.filter((link) => link.franchisee_dashboard === true);
  },
}));

export { useLinkStore };
